/**
 * GUERLAIN specific configuration.
 *
 * This will be merged with `src/config/index.ts`
 */

import customerDataForm from "./forms/customerData";
import customerConsentForm from "./forms/customerConsent";
import customerAdditionalInfo from "./forms/customerAdditionalInfo";
import advisorForm from "./forms/advisorForm";

const urlParams = new URLSearchParams(window.location.search);
const auth0Mode: string = urlParams.get("auth0")!;
if (auth0Mode) {
  console.log("auth0Mode:", auth0Mode);
}

const supportedLanguages = ["en", "fr", "en-CA", "fr-CA"];

const stage: string = process.env.REACT_APP_STAGE || "local";
const AUTH_BASE_URL =
  "https://login.microsoftonline.com/bddddbb1-db54-40d5-b230-0609bcef2068";

const [BACKEND_BASE_URL, AUTH_CLIENT_ID] =
  stage === "local" || stage === "dev" // localhost or dev
    ? [
        "https://ddc-backend-proxy.dev.guerlain.clienteling.lvmhda.com",
        "679b163e-f39e-4f78-8c1a-160490c6212c"
      ]
    : stage === "staging" || stage === "sta"
    ? [
        "https://ddc-backend-proxy.staging.guerlain.clienteling.lvmhda.com",
        "10c60849-4c78-4543-9581-b5cf60d3b982"
      ]
    : [
        // prod
        "https://ddc-backend-proxy.guerlain.clienteling.lvmhda.com",
        "1dafa846-b33a-410e-a0e7-184a7eaba869"
      ];

export default {
  id: "guerlain",
  defaultZone: "europe",
  languages: {
    supportedLanguages,
    loadPath:
      "https://src-guerlain.secure.force.com/digitalcard/services/apexrest/ddcpub/v0/translations/{{lng}}/{{ns}}"
  },
  services: {
    oidc: auth0Mode
      ? {
          // auth0 mock
          baseUrl: "https://dev-nvp8kyt3.us.auth0.com",
          loginRedirectEndpoint: "/authorize",
          scope: "openid offline_access",
          getTokenEndpoint: "/oauth/token",
          logoutRedirectEndpoint: "/oauth2/v2.0/logout",
          clientId: "VKanawd4BmAcHHOSYxDOyhm3fH4spfGQ",
          codeChallenge: "ThisIsntRandomButItNeedsToBe43CharactersLong",
          codeChallengeMethod: "plain",
          codeVerifier: "ThisIsntRandomButItNeedsToBe43CharactersLong",
          loginRedirectParams: {
            client_id: "VKanawd4BmAcHHOSYxDOyhm3fH4spfGQ",
            response_type: "code",
            scope: "openid offline_access"
          }
        }
      : {
          baseUrl: AUTH_BASE_URL,
          loginRedirectEndpoint: "/oauth2/v2.0/authorize",
          scope: "openid offline_access",
          getTokenEndpoint: "/oauth2/v2.0/token",
          logoutRedirectEndpoint: "/oauth2/v2.0/logout",
          clientId: AUTH_CLIENT_ID,
          codeChallenge: "ThisIsntRandomButItNeedsToBe43CharactersLong",
          codeChallengeMethod: "plain",
          codeVerifier: "ThisIsntRandomButItNeedsToBe43CharactersLong"
        },
    api: {
      baseUrl: BACKEND_BASE_URL,
      getConfigEndpoint: "/ddcconfig",
      signatureEndpoint:
        "https://retail-mediation-preprod.azure-api.net/documents/v1/30/FR/signature/0",
      signatureKey: "42a9e003fa5c41c883d28c05ab32afec",
      customerEndpoint:
        "https://retail-mediation-preprod.azure-api.net/digitalcard/v1/",
      key: "f197066a3c67426584e424ceebf0785f"
    }
  },
  zones: {
    ca: {
      languages: supportedLanguages,
      supportedLanguages
    },
    fr: {
      languages: supportedLanguages,
      supportedLanguages
    }
  },
  customise: {
    fields: {
      markRequiredWithSymbol: "*",
      customFields: ["axis", "franchise", "loyalty"]
    },
    customer: {
      enableAdvisorForm: true
    }
  },
  forms: {
    schema: "form/customerFormDefinitions.json",
    fields: [
      "form/customerDataFields.json",
      "form/customerConsentFields.json",
      "form/customerThanks.json",
      "form/additionalInfoFields.json"
    ],
    customer: [
      customerDataForm,
      customerConsentForm,
      customerAdditionalInfo,
      advisorForm
    ]
  }
};
